import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import WhyBevela from "@/pages/WhyBevela";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Profile from "@/pages/Profile";
import Explore from "@/pages/Explore";
import ExploreDetail from "@/pages/ExploreDetail";
import MyBoats from "@/pages/MyBoats";
import BoatForm from "@/pages/BoatForm";
import BoatDetail from "@/pages/BoatDetail";
import About from "@/pages/About";
import Faq from "@/pages/Faq";
import { LegalNotice, PrivacyPolicy, CookiePolicy } from "@/pages/Legal";
import ScrollToTop from "@/components/ScrollToTop";
import ExtensionForm from "@/pages/ExtensionForm";
import Admin from "@/pages/Admin";
import Management from "@/pages/Management";

function HomeGate() {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user) return <Landing />;
  if (!user.onboarding_completed) return <Navigate to="/onboarding" replace />;
  return <Navigate to="/dashboard" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <LanguageProvider>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomeGate />} />
              <Route path="/acceso" element={<Auth initialMode="signin" />} />
              <Route path="/login" element={<Auth initialMode="signin" />} />
              <Route path="/registro" element={<Auth initialMode="signup" />} />
              <Route path="/recuperar" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/explorar" element={<Explore />} />
              <Route path="/explorar/:id" element={<ExploreDetail />} />
              <Route path="/sobre-nosotros" element={<About />} />
              <Route path="/por-que-bevela" element={<WhyBevela />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/aviso-legal" element={<LegalNotice />} />
              <Route path="/privacidad" element={<PrivacyPolicy />} />
              <Route path="/cookies" element={<CookiePolicy />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/onboarding" element={<Onboarding />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/perfil" element={<Profile />} />
                <Route path="/perfil/extension/:type" element={<ExtensionForm />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/mis-embarcaciones" element={<MyBoats />} />
                <Route path="/gestion" element={<Management />} />
                <Route path="/mis-embarcaciones/nueva" element={<BoatForm />} />
                <Route path="/mis-embarcaciones/:id/editar" element={<BoatForm />} />
                <Route path="/embarcacion/:id" element={<BoatDetail />} />
              </Route>
            </Route>
          </Routes>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}
